<svg
  #highlightSvg
  class="text-highlight-svg"
  aria-hidden="true"
  [attr.width]="canvasWidth"
  [attr.height]="canvasHeight"
  [style.left.px]="canvasOffsetX"
  [style.top.px]="canvasOffsetY"
>
  @for (box of boxes; track $index) {
    @let displayed = displayBox(box);
    <rect
      class="text-highlight-box"
      data-testid="preview-text-highlight-box"
      [attr.x]="displayed.x"
      [attr.y]="displayed.y"
      [attr.width]="displayed.width"
      [attr.height]="displayed.height"
      [attr.transform]="rotation(displayed)"
      rx="2"
    />
  }
</svg>
